import { InfoCircleOutlined } from '@ant-design/icons'
import { Popover, Tag } from 'antd'
import { BP_CATEGORY_TABLE, bpCategory } from '../services/BloodPressure'

// reference table of all levels, with the current category highlighted
const BpCategoryTable = ({ current }) => (
    <table className="table table-sm table-bordered mb-0 text-nowrap">
        <thead>
            <tr>
                <th>Category</th>
                <th>Systolic (mm Hg)</th>
                <th></th>
                <th>Diastolic (mm Hg)</th>
            </tr>
        </thead>
        <tbody>
            {BP_CATEGORY_TABLE.map((row) => (
                <tr key={row.label} className={current?.label === row.label ? 'table-warning fw-bold' : ''}>
                    <td><Tag color={row.color}>{row.label}</Tag></td>
                    <td>{row.systolic}</td>
                    <td>{row.join}</td>
                    <td>{row.diastolic}</td>
                </tr>
            ))}
        </tbody>
    </table>
)

// blood pressure category tag for a systolic / diastolic reading, with a reference table popover
export const BpCategoryTag = ({ systolic, diastolic }) => {
    const category = bpCategory(systolic, diastolic)

    return (
        <span>
            {category
                ? <Tag color={category.color}>{category.label}</Tag>
                : <span className="text-muted me-2">Enter systolic and diastolic</span>}
            <Popover
                title="Blood pressure categories"
                trigger="click"
                content={<BpCategoryTable current={category} />}
            >
                <InfoCircleOutlined
                    className="text-secondary"
                    style={{ cursor: 'pointer' }}
                    aria-label="Show blood pressure category table"
                />
            </Popover>
        </span>
    )
}
